import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config';

const Agent = () => {
  const [admins, setAdmins] = useState([]);
  const [editAdmin, setEditAdmin] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [showAddAgentForm, setShowAddAgentForm] = useState(false);
  const [newAgent, setNewAgent] = useState({
    username: '',
    nickname: '',
    email: '',
    mobileNumber: '',
    password: '',
    isRole: 1,
    isAdmin: true
  });
  const [errors, setErrors] = useState({});
  
  const navigate = useNavigate();

  const fetchAdmins = () => {
    axios.get('/api/v1/admin/users', { withCredentials: true })
      .then(res => setAdmins(res.data.filter(user => user.isRole === 1)))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    fetchAdmins();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    try {
      return new Date(dateString).toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch (e) {
      return 'Invalid date';
    }
  };

  
  const handleDelete = async (adminId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    try {
      await axios.delete(`/api/v1/admin/users/${adminId}`, {
        withCredentials: true
      });
      fetchAdmins();
    } catch (err) {
      console.error('Delete error:', err);
      alert('Failed to delete user');
    }
  };

  const handleEdit = (admin) => {
    setEditAdmin(admin);
    setModalOpen(true);
  };

  const handleSaveEdit = async () => {
    try {

        // Prepare the update data
    const updateData = {
      username: editAdmin.username,
      nickname: editAdmin.nickname,
      mobileNumber: editAdmin.mobileNumber
    };

    // Only include password if it was changed (and not empty)
    if (editAdmin.password && editAdmin.password.trim() !== '') {
      updateData.password = editAdmin.password;
    }

    await axios.put(`/api/v1/admin/users/${editAdmin._id}`, updateData, {
      withCredentials: true
    });
  
      fetchAdmins();
      setModalOpen(false);
    } catch (err) {
      console.error('Edit error:', err);
      alert('Failed to update admin');
    }
  };

  const handleAddAgentChange = (e) => {
    const { name, value } = e.target;
    setNewAgent({
      ...newAgent,
      [name]: value
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newAgent.username) newErrors.username = 'Username is required';
    if (!newAgent.nickname) newErrors.nickname = 'Display name is required';
    if (!newAgent.email) newErrors.email = 'Email is required';
    if (!newAgent.mobileNumber) newErrors.mobileNumber = 'Mobile number is required';
    if (!newAgent.password || newAgent.password.length < 6) newErrors.password = 'Password must be at least 6 characters';
    return newErrors;
  };

  const handleAddAgentSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
  
    try {
      const agentData = {
        username: newAgent.username,
        nickname: newAgent.nickname,
        email: newAgent.email,
        mobileNumber: newAgent.mobileNumber,
        password: newAgent.password
      };
  
      await axios.post(`${BASE_URL}/api/v1/user/create-admin`, agentData, {
        withCredentials: true
      });
  
      fetchAdmins();
      setShowAddAgentForm(false);
      setNewAgent({
        username: '',
        nickname: '',
        email: '',
        mobileNumber: '',
        password: '',
        isRole: 1,
        isAdmin: true
      });
      setErrors({});
      alert('Agent created successfully!');
    } catch (err) {
      console.error('Add agent error:', err);
      alert(err.response?.data?.message || 'Failed to create agent');
    }
  };
  return (
    // <div className="flex-1 p-8">
    //   <div className="flex justify-between items-center mb-4">
    //     <h2 className="text-2xl font-semibold">Admins</h2>
    //     <button 
    //       onClick={() => setShowAddAgentForm(true)}
    //       className="flex items-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
    //     >
    //       <span className="mr-2">+</span>
    //       Add Agent
    //     </button>
    //   </div>

    <div className="flex-1 p-4 md:p-6">
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-2">
      <h2 className="text-xl md:text-2xl font-semibold">Admins</h2>
      <button 
        onClick={() => setShowAddAgentForm(true)}
        className="flex items-center bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors self-end md:self-auto w-auto"
      >
        <span className="mr-2">+</span>
        Add Agent
      </button>
    </div>


      {/* Add Agent Form Modal */}
      {showAddAgentForm && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg w-96">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Create New Agent</h3>
              <button 
                onClick={() => {
                  setShowAddAgentForm(false);
                  setErrors({});
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            </div>
            
            <form onSubmit={handleAddAgentSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700 mb-2">Agent Name</label>
                <input
                  type="text"
                  name="username"
                  value={newAgent.username}
                  onChange={handleAddAgentChange}
                  className={`p-2 border ${errors.username ? 'border-red-500' : 'border-gray-300'} rounded w-full`}
                  placeholder="Enter agent name"
                />
                {errors.username && <p className="text-red-500 text-sm mt-1">{errors.username}</p>}
              </div>

              <div className="mb-4">
              <label className="block text-gray-700 mb-2">Display Name</label>
              <input
                type="text"
                name="nickname"
                value={newAgent.nickname}
                onChange={handleAddAgentChange}
                className={`p-2 border ${errors.nickname ? 'border-red-500' : 'border-gray-300'} rounded w-full`}
                placeholder="Enter nick name"
              />
              {errors.nickname && <p className="text-red-500 text-sm mt-1">{errors.nickname}</p>}
            </div>

              <div className="mb-4">
                <label className="block text-gray-700 mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={newAgent.email}
                  onChange={handleAddAgentChange}
                  className={`p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded w-full`}
                  placeholder="Enter email"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 mb-2">Mobile Number</label>
                <input
                  type="text"
                  name="mobileNumber"
                  value={newAgent.mobileNumber}
                  onChange={handleAddAgentChange}
                  className={`p-2 border ${errors.mobileNumber ? 'border-red-500' : 'border-gray-300'} rounded w-full`}
                  placeholder="Enter mobile number"
                />
                {errors.mobileNumber && <p className="text-red-500 text-sm mt-1">{errors.mobileNumber}</p>}
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-medium text-gray-700 mb-2">Login Details</h4>
                <div className="mb-3">
                  <label className="block text-gray-700 mb-1">Username</label>
                  <input
                    type="text"
                    name="username"
                    value={newAgent.username}
                    onChange={handleAddAgentChange}
                    className={`p-2 border ${errors.username ? 'border-red-500' : 'border-gray-300'} rounded w-full`}
                    placeholder="Enter username for login"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Password</label>
                  <input
                    type="password"
                    name="password"
                    value={newAgent.password}
                    onChange={handleAddAgentChange}
                    className={`p-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded w-full`}
                    placeholder="Enter password"
                  />
                  {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
                </div>
              </div>

              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddAgentForm(false);
                    setErrors({});
                  }}
                  className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Create Agent
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      
<div className="bg-white rounded-xl shadow">
        {/* Mobile View */}
        <div className="md:hidden">
          {admins.map(admin => (
            <div key={admin._id} className="border-b p-4 last:border-b-0">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h3 className="font-semibold">{admin.username}</h3>
                  <p className="text-gray-600 text-sm">{admin.nickname}</p>
                  <p className="text-gray-600 text-sm">{admin.email}</p>
                  <p className="text-gray-600 text-sm">{admin.mobileNumber}</p>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <div className="text-sm text-gray-500">
                    {new Date(admin.createdAt).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric'
                    }).replace(/ /g, '-')}
                  </div>
                  <div className="text-xs text-gray-400">
                    Last Active: {formatDate(admin.lastActive)}
                  </div>
                </div>
              </div>
              
              <div className="mt-3 flex justify-end gap-2">
                <button
                  onClick={() => navigate(`/admin-dashboard/users/${admin._id}`)}
                  className="text-blue-600 text-sm px-2 py-1"
                >
                  View
                </button>
                <button
                  onClick={() => handleEdit(admin)}
                  className="text-yellow-600 text-sm px-2 py-1"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(admin._id)}
                  className="text-red-600 text-sm px-2 py-1"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full min-w-[800px]">
            <thead className="bg-gray-50">
              <tr className="text-left border-b">
                <th className="p-4">Name</th>
                <th className="p-4">Nick Name</th>
                <th className="p-4">Email</th>
                <th className="p-4">Mobile</th>
                <th className="p-4">Created</th>
                <th className="p-4">Last Active</th>
                <th className="p-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {admins.map(admin => (
                <tr key={admin._id} className="border-b hover:bg-gray-50">
                  <td className="p-4">{admin.username}</td>
                  <td className="p-4">{admin.nickname || '-'}</td>
                  <td className="p-4">{admin.email}</td>
                  <td className="p-4">{admin.mobileNumber}</td>
                  <td className="p-4">
                    {new Date(admin.createdAt).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric'
                    }).replace(/ /g, '-')}
                  </td>
                  <td className="p-4">{formatDate(admin.lastActive)}</td>
                  <td className="p-4 space-x-2">
                    <button
                      onClick={() => navigate(`/admin-dashboard/users/${admin._id}`)}
                      className="text-blue-600 hover:text-blue-800"
                    >
                      View
                    </button>
                    <button
                      onClick={() => handleEdit(admin)}
                      className="text-yellow-600 hover:text-yellow-800"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(admin._id)}
                      className="text-red-600 hover:text-red-800"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Edit Admin Modal - make responsive */}
      {modalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="p-4 md:p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg md:text-xl font-semibold">Edit Admin</h3>
                <button
                  onClick={() => setModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  &times;
                </button>
              </div>
              
              <div className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                  <input
                    type="text"
                    value={editAdmin.username}
                    onChange={(e) => setEditAdmin({ ...editAdmin, username: e.target.value })}
                    className="w-full p-2 border rounded"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nickname</label>
                  <input
                    type="text"
                    value={editAdmin.nickname}
                    onChange={(e) => setEditAdmin({ ...editAdmin, nickname: e.target.value })}
                    className="w-full p-2 border rounded"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    value={editAdmin.email}
                    readOnly
                    className="w-full p-2 border rounded bg-gray-100"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
                  <input
                    type="text"
                    value={editAdmin.mobileNumber}
                    onChange={(e) => setEditAdmin({ ...editAdmin, mobileNumber: e.target.value })}
                    className="w-full p-2 border rounded"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Password (optional)</label>
                  <input
                    type="password"
                    value={editAdmin.password || ''}
                    onChange={(e) => setEditAdmin({ ...editAdmin, password: e.target.value })}
                    className="w-full p-2 border rounded"
                    placeholder="Leave blank to keep current"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setModalOpen(false)}
                  className="px-4 py-2 text-gray-600 hover:bg-gray-50 rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveEdit}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
    

      )}
    </div>
  );
};

export default Agent;